import { useWindowDimensions } from "react-native";

export function useDeviceType(breakpoint = 1024) {
  const { width } = useWindowDimensions();
  return {
    isDesktop: width >= breakpoint,
    isTablet: width >= 768 && width < breakpoint,
    isMobile: width < 768,
    width,
  };
}
